import { useEffect, useRef } from 'react';
import useDeprecate from './useDeprecate';

/**
 * Lorem ipsum
 * @param initialValue boolean
 * @returns ref
 * @see Overlay Table
 * @deprecated This uses an anti-pattern of mutating a ref from a useEffect.
 *
 * You should instead handle whatever this was used for yourself in the unmount cleanup function.
 *
 * More info: https://medium.com/doctolib/react-stop-checking-if-your-component-is-mounted-3bb2568a4934
 */
export default function useMounted() {
  let initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  useDeprecate(true, '@adsk/alloy-react-helpers', 'useMounted', 'the useEffect unmount cleanup function (see https://medium.com/doctolib/react-stop-checking-if-your-component-is-mounted-3bb2568a4934)');
  const isMountedRef = useRef(initialValue);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef;
}
//# sourceMappingURL=useMounted.js.map